import { createRicosFunctionalExtension, isInsideList } from './../../plugin-commons';

export const tab = createRicosFunctionalExtension({
  type: 'extension',
  groups: ['shortcuts-enabled'],
  name: 'tab',
  createExtensionConfig() {
    return {
      name: this.name,
      priority: 101,

      addKeyboardShortcuts() {
        return {
          Tab: () => {
            if (!isInsideList(this.editor.view.state)) {
              this.editor.commands.insertContent('\t');
              return true;
            }

            return false;
          },
        };
      },
    };
  },
});
